import { Main } from './style'
import Ecossistema from '../../components/Ecossistema'
import DadosEcossistema from '../../components/DadosEcossistema'
import CadastrarPlataforma from '../../components/CadastrarPlataforma'

const Home = () => {
    return (
        <Main>
            <Ecossistema />
            <DadosEcossistema />
            <CadastrarPlataforma />
        </Main>
    )
}
export default Home
